import { Injectable } from '@angular/core';

import { TokenControlService } from "../services/state/tokenControl.service";
import { ActivatedRoute, Router } from '@angular/router';
import { Component } from '@angular/core';

@Injectable()
export class LoggedinGuard  {

  //Indica si ya se realizo correctamente un login
  public loggedIn:boolean;

  //Constructor de la clase
  constructor(private _router: Router) {
      this.loggedIn=false;
  }

  /*Necesario debido a implementacion de la interfaz CanActivate
    funcion principal del guard, verifica si se cumplen las
    condiciones para permitir la navegacion */
  canActivate() {
      let canActivate = false;
      if(this.loggedIn){
        canActivate=true;
      }else{
        this._router.navigate(['/']);
      }
    return canActivate
  }


}
